import { Component } from '@angular/core'


@Component({
  selector: 'hyperkit-card',
  standalone: true,
  imports: [],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {}
